import {EntityType, NewJoinerChecklistItem, NewJoinerChecklistItemForm} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {officeArrayResource} from "./CurrentOfficeStore";
import {NewJoinerChecklistItems_Read} from "../util/access/Permission";

interface NewJoinerChecklistItemStore extends EntityStore<NewJoinerChecklistItem[]> {
    createNewJoinerChecklistItem: (form: NewJoinerChecklistItemForm) => Promise<NewJoinerChecklistItem>;
    updateNewJoinerChecklistItem: (item: NewJoinerChecklistItem, form: NewJoinerChecklistItemForm) => Promise<NewJoinerChecklistItem>;
    deleteNewJoinerChecklistItem: (item: NewJoinerChecklistItem) => Promise<void>;
}

export const useNewJoinerChecklistItemStore = create<NewJoinerChecklistItemStore>()(
    officeArrayResource<NewJoinerChecklistItem, NewJoinerChecklistItemStore>(EntityType.NewJoinerChecklistItems, builder => {
        const rest = builder.crud('/new-joiner/checklist-items', 'id');

        return {
            remoteValue: builder.all(NewJoinerChecklistItems_Read, () => rest.getAll()),
            createNewJoinerChecklistItem: builder.createAndPatch<NewJoinerChecklistItemForm>(rest),
            updateNewJoinerChecklistItem: builder.updateAndPatch<NewJoinerChecklistItemForm>(rest),
            deleteNewJoinerChecklistItem: builder.deleteAndPatch(rest),
        };
    })
);

startEntityStore(useNewJoinerChecklistItemStore);
